import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#23DB85",
      "fill-rule": "evenodd",
      d: "M3.998 0H.605A.6.6 0 0 0 0 .593v14.81c0 .329.27.594.605.594h3.103a.6.6 0 0 0 .605-.593V7.632c0-.112.032-.222.093-.317l2.068-3.209a.58.58 0 0 0 .007-.623L4.516.287A.6.6 0 0 0 3.998 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-opacity": ".1",
      "fill-rule": "evenodd",
      d: "M3.998 0H.605A.6.6 0 0 0 0 .593v14.81c0 .329.27.594.605.594h3.103a.6.6 0 0 0 .605-.593V7.632c0-.112.032-.222.093-.317l2.068-3.209a.58.58 0 0 0 .007-.623L4.516.287A.6.6 0 0 0 3.998 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#23DB85",
      "fill-rule": "evenodd",
      d: "M16.608 0H13.43c-.208 0-.4.104-.511.276L6.568 10.12a.58.58 0 0 0 0 .636l1.057 1.622a.61.61 0 0 0 .516.277h.933a.62.62 0 0 0 .515-.276l2.978-4.554c.18-.277.619-.152.619.177v7.402c0 .328.27.593.605.593h2.817a.6.6 0 0 0 .605-.593V.594A.6.6 0 0 0 16.608 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-opacity": ".1",
      "fill-rule": "evenodd",
      d: "M16.608 0H13.43c-.208 0-.4.104-.511.276L6.568 10.12a.58.58 0 0 0 0 .636l1.057 1.622a.61.61 0 0 0 .516.277h.933a.62.62 0 0 0 .515-.276l2.978-4.554c.18-.277.619-.152.619.177v7.402c0 .328.27.593.605.593h2.817a.6.6 0 0 0 .605-.593V.594A.6.6 0 0 0 16.608 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }